<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div class="title">修改手机号</div>
    <div class="line"></div>
    <div style="width: 1.8854rem;height: .9479rem;margin-top: .2552rem;margin-left: .1823rem;">
      <div class="text">当前手机号：{{ oldphone }}</div>
      <div class="flex">
        <div class="txt">新手机号</div>
        <div class="xing">*</div>
        <el-input v-model.lazy="phone" placeholder="请输入" :style="{ width: '1.4792rem', height: '.1667rem' }"></el-input>
      </div>
      <div class="flex">
        <div class="txt">验证码</div>
        <div class="xing">*</div>
        <el-input v-model="code" placeholder="请输入" :style="{ width: '.9063rem', height: '.1667rem' }">
        </el-input> <button @click="sendCode()" :disabled="countdown > 0" :class="{ 'disabled': countdown > 0 }">{{
          countdown > 0 ?
          countdown + 's后再次获取' : '获取验证码' }}</button>
      </div>
      <button style="margin-top: .0938rem;margin-left:.4063rem;" @click="xiugai">立即修改</button>
      <button class="other" style="margin-top: .0938rem;" @click="quxiao()">取消</button>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: '',
      code: '',
      countdown: 0,
      timer: null,
      Authorization: '',
      oldphone: ''
    }
  },
  methods: {
    quxiao() {
      this.phone = ''
      this.code = ''
    },
    sendCode() {
      // 发送验证码的逻辑
      // ...

      // 开始倒计时
      let formdataphone = new FormData()
      formdataphone.append('phone', this.phone)
      this.$http.post('/Api/User/User/Web/Phone/Update', formdataphone, {
        headers: {
          'Authorization': this.Authorization
        }
      }).then(res => {
        console.log(res);
      })
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    xiugai() {
      if (this.phone == '' || this.code == '' || this.newpwd == '') {
        this.$message({
          message: '请填写完整信息',
          type: 'error'
        });
        return false
      }
      let obj = {
        phone: this.phone,
        code: this.code
      }
      this.$http.post('/Api/User/User/Web/Phone/Update/Callback', JSON.stringify(obj), {
        headers: {
          'Authorization': this.Authorization,
          "Content-Type": "application/json"
        }
      }).then(res => {
        console.log(res, 5);
        this.$message(res.data.msg);
        localStorage.setItem('isPhone', '1');

      })
      // let phoneobj = {
      //   phone: this.phone
      // }
      // this.$http.put('/Api/Teacher', JSON.stringify(phoneobj), {
      //   headers: {
      //     'Authorization': this.Authorization,
      //     "Content-Type": "application/json"
      //   }
      // }).then(res => {
      //   console.log(res);
      // })
    }

  },
  created() {
    this.Authorization = localStorage.getItem('Authorization')
  }

}
</script>

<style scoped > button.disabled {
   opacity: 0.5;
   cursor: not-allowed;
 }

 .flex {
   display: flex;
   margin-top: 18px;
 }

 .title {
   /* 修改手机号 */
   height: 38px;
   color: rgb(0, 0, 0);
   font-family: 苹方;
   font-size: 36px;
   font-weight: 400;
   line-height: 38px;
   letter-spacing: 0px;
   text-align: left;

 }

 .line {
   /* Line */
   width: 750px;
   height: 2px;
   background: rgb(220, 223, 230);
   margin-top: 16px;
 }

 .text {
   /* 当前手机号：182****2222 */
   height: 22px;
   color: rgb(48, 49, 51);
   font-family: 苹方;
   font-size: 14px;
   font-weight: 550;
   line-height: 22px;
   letter-spacing: -0.009999999776482582px;
   text-align: left;
 }

 .code {
   /* 验证码 */
   width: 150px;
   height: 30px;
   margin-top: 31px;
   margin-left: 10px;
   border: 2px solid rgba(0, 0, 0, 0.3);
   padding-left: 10px;
 }

 .txt {
   /* 新手机号 */

   width: 56px !important;
   height: 22px;
   color: rgb(48, 49, 51);
   font-family: 苹方;
   font-size: 14px;
   font-weight: 400;
   line-height: 32px;
   letter-spacing: -0.009999999776482582px;
   text-align: left;
 }

 .xing {
   color: rgb(245, 108, 108);
   font-size: 14px;
   font-weight: 600;
   width: 22px;
   text-align: center;
   transform: translateY(8px);
 }


 button {
   width: 90px;
   height: 32px;
   background: rgb(1, 162, 153);
   border-radius: 4px;
   border: none;
   /* Small Button */
   color: rgb(255, 254, 254);
   font-family: Microsoft YaHei;
   font-size: 13px;
   font-weight: 400;
   line-height: 14px;
   letter-spacing: 0px;
   text-align: center;
   margin-left: 20px;
 }

 /deep/ .el-input__inner {
   height: 32px;
 }

 .other {
   width: 72.92px;
   height: 32px;
   background: rgb(255, 255, 255);
   border: 1px solid rgb(220, 223, 230);
   border-radius:
     4px;
   /* 取消 */

   color: rgb(96, 98, 102);
   font-family: 苹方;
   font-size: 14px;
   font-weight: 400;
   line-height: 22px;
   letter-spacing: -0.009999999776482582px;
   text-align: center;


 }
</style>



// WEBPACK FOOTER //
// src/components/pages/studentphone.vue